import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="central-template-row">
      <div className="central-template-col-no">{displayNo}</div>

      <div className="central-template-col-title">
        <Link
          to={`/documents/central-committee/${item.id}`}
          className="central-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="central-template-col-writer">{item.writer}</div>
      <div className="central-template-col-date">{item.date}</div>
      <div className="central-template-col-view">{item.view}</div>
    </div>
  );
}